import ACCOUNT from "../../../../Core/TESTS/ACCOUNT";
import { ACTIONS } from "../../../../Models/ENUM";
import ARRAY from "../../../../UTIL/ARRAY";
import CONQUER from "../../../CONQUER";
import FeedInstance from "../FeedInstance";

class FollowerInstance
{
    private feedInstance    : FeedInstance;
    private conquer         : CONQUER;
    public avatarID         : any;
    public fullName         : any;
    public userPhoto        : any;
    public membershipID     : any;
    public status           : any;
 
    constructor( conquer:CONQUER, feedInstance:FeedInstance, vars:any )
    {
        this.conquer        = conquer;
        this.feedInstance   = feedInstance;

        this.fill( vars );
    };

    private fill( vars:any )
    {
        this.avatarID       = vars.avatarID || this.avatarID;
        this.fullName       = vars.fullName || this.fullName;
        this.userPhoto      = vars.userPhoto || this.userPhoto;

        this.refresh( vars );
    }

    public async get() : Promise<any>
    {
        let data            = await this.conquer.do( ACTIONS.FOLLOWERS_GETONE );

        this.refresh( data );

        return Promise.resolve();
    }

    private refresh( data?:any )
    {
        this.membershipID   = null;
        this.status         = null;

        if( !data ) return;

        this.membershipID   = data._id;
        this.status         = data.status;
    }

    public async set() : Promise<any>
    {
        if( this.membershipID ) return Promise.resolve();
 
        let membership      = await this.conquer.do( ACTIONS.FOLLOWERS_SET, { graphID:this.feedInstance.feedID } );
 
        this.refresh( membership );

        return Promise.resolve();
    }

    public remove()
    {
        if( !this.membershipID ) return;

        this.refresh();

        this.conquer.do( ACTIONS.FOLLOWERS_REMOVE, { graphID:this.feedInstance.feedID });
 
    }
 
}

export default FollowerInstance;